// extracted by mini-css-extract-plugin
export default {"container":"R5Component_container__0dQ9p","label":"R5Component_label__XofAC","question":"R5Component_question__Hc6wt"};